import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { DataList, Package, PackageSwapResponse, PayloadBookingPackage, RegisterBookingResponse } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class PackageService {
  constructor(private apiService: ApiService) {}

  trainingPackages(gymId: number | null = null, length: number = 25): Observable<DataList<Package>> {
    let url = `user/training_packages?length=${length}`;
    if (gymId) {
      url += `&gym_id=${gymId}`;
    }
    return this.apiService.get<DataList<Package>>(url).pipe();
  }

  trainingPackagesSwap(gymId: number, class_id: number | null = null, session_id: number | null = null): Observable<PackageSwapResponse> {
    let url = `user/bookings/swap`;
    if (gymId) {
      url += `?gym_id=${gymId}`;
    }
    if (class_id) {
      url += `&class_id=${class_id}`;
    }
    if (session_id) {
      url += `&session_id=${session_id}`;
    }
    return this.apiService.get<PackageSwapResponse>(url).pipe();
  }

  bookingPackages(gymId: number | null = null, length: number = 25): Observable<DataList<Package>> {
    let url = `user/booking_packages?length=${length}`;
    if (gymId) {
      url += `&gym_id=${gymId}`;
    }
    return this.apiService.get<DataList<Package>>(url).pipe();
  }

  createBooking(payload: PayloadBookingPackage): Observable<RegisterBookingResponse> {
    return this.apiService.post<RegisterBookingResponse>('user/booking_packages', payload).pipe();
  }
  
}
